import { authRoutes } from "../config/authRoutes";

export function resolvePostAuthRoute(user) {
  if (!user) {
    return authRoutes.dashboard;
  }

  const isEmailVerified = String(user?.emailVerified).toLowerCase() === "true";
  const isProfileComplete = String(user?.completeProfile).toLowerCase() === "true";

  if (!isEmailVerified) {
    return authRoutes.verifyEmail;
  }

  if (user?.accountSelectionRequired) {
    return authRoutes.selectAccount;
  }

  if (!isProfileComplete) {
    return authRoutes.completeSignup;
  }

  return authRoutes.dashboard;
}
